import { Injectable } from '@angular/core';
import { DateService } from 'src/app/common/services/date.service';
import { MessageService } from 'src/app/common/services/message.service';
import {
  StartEndTimeEpochInterface,
} from '../interface/table-bookings.interface';


@Injectable()
export class TableBookingHelperService {
  constructor(
    private _msgService: MessageService,
    private _dateService: DateService
  ) {}

  // Function to get start and end timestamps for a given date
  getStartEndEpochByDate(
    date: string,
    timezone?: string
  ): StartEndTimeEpochInterface {
    try {
      const startTime = '00:00:00'; // Start time of the day
      const endTime = '23:59:59'; // End time of the day

      // Calculate start timestamp
      const startTimestamp = this._dateService.getTimeStampEpoch({
        date,
        time: startTime,
        timezone,
      });

      // Calculate end timestamp
      const endTimestamp = this._dateService.getTimeStampEpoch({
        date,
        time: endTime,
        timezone,
      });

      return { startTimeEpoch: startTimestamp, endTimeEpoch: endTimestamp };
    } catch (error) {
      console.error(
        'Error occurred while calculating start and end timestamps:',
        error
      );
      return null;
    }
  }

  apiErrorMsg(error): void {
    const errorMsg = (((error || {}).error || {}).http || {}).error;
    this._msgService.showError(errorMsg);
  }
}
